// [BD Feat] Js for the nutritional modal close and open

document.addEventListener('DOMContentLoaded', function () {
  const nutritionTrigger = document.querySelector('.open-nutrition-modal');
  const modalCloseButtons = document.querySelectorAll('.story__modal-close');

  if (nutritionTrigger) {
    nutritionTrigger.addEventListener('click', () => {
      const modal = document.getElementById('Modal-Nutrition');
      if (modal) {
        document.body.classList.add('story__modal--opened');
        modal.classList.add('open');
      }
    });
  }

  modalCloseButtons.forEach((closeButton) => {
    closeButton.addEventListener('click', () => {
      document.body.classList.remove('story__modal--opened');
      const openModal = document.querySelector('.story__modal.open');
      if (openModal) {
        openModal.classList.remove('open');
      }
    });
  });
});
